import React from 'react';
//import { TransitionGroup, CSSTransition } from "react-transition-group";

import Header from './containers/header/Header.js';
import Main from './containers/main/Main.js';
import Footer from './containers/footer/Footer.js';
import Astral from './containers/astral/Astral.js';

//import logo from './logo.svg';
import './App.css';

function App() {

  const [main, setMain] = React.useState(true);

  return (
    <div className="App">
        {main ? 
            <React.Fragment>
                <Header setMain={setMain} />
                <Main />
                <Footer />
            </React.Fragment>
            :
            <React.Fragment>
                <Astral setMain={setMain} />
	    </React.Fragment>
	}
    </div>
  );
}

export default App;
